import { render, staticRenderFns } from "./PrivateIdColumn.vue?vue&type=template&id=72041251&"
import script from "./PrivateIdColumn.vue?vue&type=script&lang=js&"
export * from "./PrivateIdColumn.vue?vue&type=script&lang=js&"
import style0 from "./PrivateIdColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72041251')) {
      api.createRecord('72041251', component.options)
    } else {
      api.reload('72041251', component.options)
    }
    module.hot.accept("./PrivateIdColumn.vue?vue&type=template&id=72041251&", function () {
      api.rerender('72041251', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/PrivateIdColumn.vue"
export default component.exports